const SECURITY_RESOLUTION_STALE_MESSAGE = (
    'The latest security resolution status is temporarily unavailable. '
    + 'Showing the last successful results while the app retries.'
);

export const mergeSecurityResolutionCenterResponse = (current, response) => {
    const currentData = current?.data;
    const currentRows = Array.isArray(currentData?.rows) ? currentData.rows : [];
    const responseStatus = String(response?.status || '').trim().toLowerCase();
    if (responseStatus === 'degraded' && currentRows.length > 0) {
        return {
            loading: false,
            error: '',
            data: {
                ...currentData,
                status: 'stale',
                message: response?.message || SECURITY_RESOLUTION_STALE_MESSAGE,
            },
        };
    }
    return {
        loading: false,
        error: '',
        data: response || null,
    };
};
